export default {
    form_text() {
        return 'form-control border-top-0 border-start-0 border-end-0 bg-transparent '
    },
    form_select() {
        return 'form-select border-top-0 border-start-0 border-end-0 rounded-0 bg-transparent '
    },
    form_add_position() {
        return 'btn btn-outline-primary py-sm-2 px-sm-5 rounded-pill bi bi-plus d-block mx-auto'
    },
    list_inline() {
        return 'd-inline-block horizontal-list text-small px-3 py-2 m-2 bg-gray text-secondary rounded-pill'
    },
    list_inline_button() {
        return 'border-0 bg-transparent  bi bi-x-lg'
    }
}